<template>
  <div class="create-credentials">
    <credentials-details-with-async-fallback
      :handle-back="deletePageParams"
      :source="source"
      :loading-start-time="loadingStartTime"
      :is-loading="isLoading">
      <template v-slot:credentials>
        <credentials-details :invalid-credentials="invalidCredentials"
                             :source="source"
                             :name-already-used-error="nameAlreadyUsedError"
                             :set-name-already-in-use-error="setNameAlreadyInUseError"
                             :save-credentials-error="saveCredentialsError"
                             :on-save="saveCredentials"/>
      </template>
    </credentials-details-with-async-fallback>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import CredentialsDetailsWithAsyncFallback from '../../../../../../base-components/onboarding/CredentialsDetailsWithAsyncFallback.vue';
import ShowUnsupportedModalMixin from '../../../unsupported-banks/ShowUnsupportedModalMixin.vue';
import sourcesFields from '../../../../../../constants/sourcesFields';
import BackNavigationHeader from '../../../../../../base-components/app-header/BackNavigationHeader.vue';
import CredentialsDetails from '../../../../../../base-components/onboarding/CredentialsDetails.vue';

export default {
  name: 'BankConnectionFlow',
  mixins: [ShowUnsupportedModalMixin],
  components: {
    CredentialsDetailsWithAsyncFallback,
    BackNavigationHeader,
    CredentialsDetails,
  },
  computed: {
    ...mapState('onboardingState', ['isLoading', 'nameAlreadyUsedError', 'saveCredentialsError', 'loadingStartTime']),
    ...mapGetters('onboardingState', ['invalidCredentials', 'sourceName']),
    source() {
      return _.find(sourcesFields.allSourceFields, { sourceName: this.sourceName });
    },
  },
  methods: {
    ...mapActions('onboardingState', ['saveCredentials', 'deletePageParams']),
    ...mapMutations('onboardingState', ['setNameAlreadyInUseError', 'setPageParams']),
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../scss/mixins';

  .create-credentials {
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/onboard2/steps/bank-selection/BankConnectionFlow.vue